import { apiConfiguration } from '../../../configurations/api-configuration';

export function resolveTeamLogoUrl(logoUrl: string | null): string | null {
  if (!logoUrl) {
    return null;
  }

  if (/^(https?:|data:|blob:)/.test(logoUrl)) {
    return logoUrl;
  }

  const apiOrigin = apiConfiguration.baseApiUrl.replace(/\/api\/?$/, '');
  return `${apiOrigin}${logoUrl}`;
}

export function resolveTeamLogoBackground(logoUrl: string | null): string | null {
  const resolvedLogoUrl = resolveTeamLogoUrl(logoUrl);
  return resolvedLogoUrl ? `url("${resolvedLogoUrl}")` : null;
}
